import { axiosInstance } from "./config";

const BASE_URL = "/excel";

export const uploadExcel = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post(`${BASE_URL}/upload-exceljs`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadCandidateCsv = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post(`${BASE_URL}/upload-csv`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 0,
  });
};
    
